<header>
    <div class="header">
      <div>
        <button mat-button [matMenuTriggerFor]="panel.menu" *ngIf="usuario && usuario.nome">
          <mat-icon>menu</mat-icon>
        </button>
        <app-menu-panel #panel [items]="menuItems"></app-menu-panel>
      </div>
      <div class="logo-side">
        <a href="/app/dashboard">
          <img class="logo" [src]="'assets/images/logo2.png' | baseUrl" alt="Logo Sequoia">
        </a>
        <form *ngIf="habilitarPesquisa" [formGroup]="searchForm">
          <div class="input-search">
            <input formControlName="search" type="text" placeholder="Localizar menu..." class="search-input">
            <button class="search-button" (click)="abrirModalPesquisa(menuItems)">
              <mat-icon>search</mat-icon>
            </button>
          </div>   
        </form>
      </div>
      <div class="user-side" *ngIf="usuario && usuario.nome">
        <div class="user-side--content">
          <button mat-button [matMenuTriggerFor]="menuUser">
            <div class="menu-user">
              <div class="photo">
                <img [src]="'assets/images/user.jpg' | baseUrl" alt="Foto">
              </div>

              <p class="name">{{ usuario.nome }}<br />
                <small>{{ usuario.descricao }}</small></p>

              <i class="fas fa-chevron-down"></i>
            </div>
          </button>
          <mat-menu #menuUser="matMenu" xPosition="before">
            <button class="user-content-button" (click)="abrirModalPerfil()" mat-menu-item>
              <i class="fas fa-user"></i>
              Perfil
            </button>
            <button class="user-content-button" (click)="logout()" mat-menu-item>
              <i class="fas fa-sign-out-alt"></i>
              Sair
            </button>
          </mat-menu>
        </div>
      </div>
    </div>
  </header>
